<template>
  <div class="feed-list-area">
    <div
      class="feed-item"
      :id="`i${item.id}`"
      v-for="item in feedItems"
      :key="item.id"
    >
      <div
        v-if="item.format === 'image'"
        class="feed-item__content"
        v-bind:style="{ height: getImageHeight(item) + 'px' }"
      >
        <img v-lazy="item.feed.url" />
      </div>
      <div v-if="item.format === 'gallery'">
        <splide :slides="item.galleryPhotos" :options="splideOptions">
          <splide-slide v-for="photo in item.galleryPhotos" :key="photo.id">
            <div class="gallery-photo-container">
              <img v-lazy="photo.display.url" />
            </div>
          </splide-slide>
        </splide>
      </div>
      <div v-if="item.format === 'video'"></div>
      <div class="feed-item__footer">
        <div class="feed-item__title" v-html="item.feed.title"></div>
        <div v-html="item.feed.caption"></div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "../mixins/debounce";
import Constants from "../assets/constants";
import VueScrollTo from "vue-scrollto";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

export default {
  name: "ImageFeed",
  mixins: [debounce],
  components: {
    Splide,
    SplideSlide
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      splideOptions: {
        rewind: false,
        pagination: false,
        perPage: 1
      }
    };
  },
  methods: {
    backToHome: function() {
      this.$router.push("/");
    },
    checkForLazyLoad: function() {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >
        document.documentElement.offsetHeight - 20;

      if (bottomOfWindow) {
        this.$store.dispatch("loadMorePosts", Constants.FEED_ITEMS_PER_PAGE);
      }
    },
    setWindowWidth: function() {
      this.windowWidth = window.innerWidth;
    },
    getImageHeight: function(image) {
      let computedHeight = Math.round(
        (image.feed.height / image.feed.width) *
          (this.windowWidth < 640 ? this.windowWidth : 500)
      );
      return computedHeight;
    }
  },
  mounted() {
    if (!this.$store.state.loadedPosts.length) {
      this.$store.dispatch("loadMorePosts", Constants.FEED_ITEMS_PER_PAGE);
      this.$store.dispatch("loadMorePosts", Constants.FEED_ITEMS_PER_PAGE);
    }

    if (this.$store.state.feedPostId !== null) {
      this.$nextTick(() => {
        VueScrollTo.scrollTo(`#i${this.$store.state.feedPostId}`, 50, {
          offset: -100,
          force: false
        });
      });
    }
    this.setWindowWidth();

    let debouncedLazyLoadFn = this.pDebounce(this.checkForLazyLoad, 100);
    let debouncedWindownWidthFn = this.pDebounce(this.setWindowWidth, 100);
    window.addEventListener("scroll", debouncedLazyLoadFn); //Debouncing for performance benefit
    window.addEventListener("resize", debouncedWindownWidthFn); //Debouncing for performance benefit
  },
  computed: {
    feedItems() {
      return this.$store.state.loadedPosts;
    }
  }
};
</script>

<style lang="scss">
.feed-list-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: $brand-grey-20;
}
.feed-item {
  width: 99%;
  position: relative;
  background-color: $brand-light-90;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  border: 1px solid $brand-grey-50;

  &__footer {
    height: auto;
    background: $brand-light-100;
    display: flex;
    flex-direction: column;
    padding: 8px;
    font-size: 13px;
  }
  &__title {
    font-weight: 700;
  }
  &__content img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
.gallery-photo-container {
  width: 100%;
  height: 375px;
  position: relative;

  img {
    display: block;
    max-width: 100%;
    max-height: 375px;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
//Styles specific for large devices
@media (min-width: 640px) {
  .feed-item {
    width: 500px;
  }
  .gallery-photo-container {
    width: 500px;
    img {
      max-width: 500px;
    }
  }
}
</style>
